import { Button, ButtonProps, CircularProgress } from '@mui/material';
import SyncIcon from '@mui/icons-material/Sync';
import CheckIcon from '@mui/icons-material/Check';
import CancelIcon from '@mui/icons-material/Cancel';
import { PartnerPlatformSyncJob } from '../../interfaces/PartnerPlatform/PartnerPlatformSyncJob';

type SyncJobButtonProps = ButtonProps & {
  isStarting: boolean;
  syncJob?: PartnerPlatformSyncJob;
  onStart: () => void;
};

export const SyncJobButton = ({
  isStarting,
  syncJob,
  onStart,
  ...props
}: SyncJobButtonProps) => {
  if (isStarting) {
    return (
      <Button
        variant='outlined'
        startIcon={<CircularProgress size={16} />}
        {...props}
      >
        Eşitleme başlatılıyor...
      </Button>
    );
  }

  switch (syncJob?.status) {
    case 'pending':
      return (
        <Button
          variant='outlined'
          startIcon={<CircularProgress size={16} />}
          {...props}
        >
          Eşitleme kuyrukta...
        </Button>
      );
    case 'processing':
      return (
        <Button
          variant='outlined'
          startIcon={<CircularProgress size={16} />}
          {...props}
        >
          Eşitleniyor{' '}
          {syncJob?.totalCount
            ? `(${syncJob.processedCount}/${syncJob.totalCount})`
            : ''}
        </Button>
      );
    case 'success':
      return (
        <Button
          variant='outlined'
          color='success'
          startIcon={<CheckIcon />}
          {...props}
        >
          Eşitleme başarılı
        </Button>
      );
    case 'failed':
      return (
        <Button
          variant='outlined'
          color='error'
          startIcon={<CancelIcon />}
          {...props}
        >
          Eşitleme hatası
        </Button>
      );
    default:
      return (
        <Button
          variant='outlined'
          startIcon={<SyncIcon />}
          onClick={onStart}
          {...props}
        >
          Eşitle
        </Button>
      );
  }
};
